import _ from 'underscore';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AdminConstants from 'constants/AdminConstants';
import registerStore from 'utils/StoreUtils';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import InvoiceCollection from './entities/invoice-collection';
var ActionTypes = AdminConstants.ActionTypes;
var CHANGE_EVENT = AdminConstants.collectionChangeEvents;
const INVOICE_UPDATE_EVENT = 'INVOICE_UPDATED';
var selectedInvoice = null;
var invoiceCollection = new InvoiceCollection();
let invoiceRegenerateSuccessful = false;
let updatedInvoice = null;
var invoices = function () {
    return invoiceCollection.toJSON();
};
var watchedInvoices = new InvoiceCollection();
const InvoiceStore = assign({}, EventEmitter.prototype, {
    // Public API: Getters (used by controller-views)
    emitChange(event) {
        this.emit(event);
    },
    addChangeListener(callback) {
        this.on(INVOICE_UPDATE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(INVOICE_UPDATE_EVENT, callback);
    },
    getInvoice: function (id) {
        var invoice = invoiceCollection.get(id);
        if (!invoice)
            return null;
        return invoice.toJSON();
    },
    getAllInvoices: function () {
        return invoices();
    },
    getInvoicesByCarrier: function (carrier) {
        return _.where(invoices(), { carrier: carrier });
        // return arrayToJSON( Invoices.where({overdue:true}) );
    },
    getWatchedInvoices: function () {
        return watchedInvoices.toJSON();
    },
    getSelectedInvoice: function () {
        return selectedInvoice;
    },
    // Public API: Handler Registration
    register: function (callback) {
        invoiceCollection.on(CHANGE_EVENT, callback);
    },
    unregister: function (callback) {
        invoiceCollection.off(CHANGE_EVENT, callback);
    },
    // Event Handlers for Dispatcher (unpack action and call Public API)
    onReceiveInvoices: function (action) {
        invoiceCollection.reset(action.data);
    },
    onReceiveInvoice: function (action) {
        var invoice = action.data, current;
        // If we are getting an update of the current invoice
        // reuse the shipper data and jobs
        if (invoiceCollection.length === 1 &&
            (current = invoiceCollection.at(0)).id === invoice._id) {
            invoice.shipper = current.get('shipper');
            invoice.jobs = current.get('jobs');
        }
        invoiceCollection.set([invoice], { remove: false });
    },
    onWatchInvoice: function (action) {
        selectedInvoice = action.data;
        watchedInvoices.add(selectedInvoice);
    },
    onUnwatchInvoice: function (action) {
        watchedInvoices.remove(action.data);
    },
    onAddInvoices: function (action) {
        // if( console && console.time )
        //    console.time('Adding items to collection');
        // This is too slow
        // invoiceCollection.set( action.data, {remove: false} );
        // This is faster, but still slow
        // invoiceCollection.add( action.data );
        // Much better
        invoiceCollection.reset(invoiceCollection.toJSON().concat(action.data));
        // if( console && console.time )
        //    console.timeEnd('Adding items to collection');
    },
    setUpdatedInvoice(invoice) {
        updatedInvoice = invoice;
    },
    onInvoiceUpdateSuccess(response) {
        this.setUpdatedInvoice(response.invoice || response.data);
    },
    onInvoiceUpdateFail() {
        this.emitChange(INVOICE_UPDATE_EVENT);
    },
    getInvoiceRegenerationStatus() {
        return invoiceRegenerateSuccessful;
    },
    getUpdatedInvoice() {
        return updatedInvoice;
    },
});
var handlers = {};
handlers[ActionTypes.RECEIVE_INVOICES] = 'onReceiveInvoices';
handlers[ActionTypes.RECEIVE_INVOICE] = 'onReceiveInvoice';
handlers[ActionTypes.WATCH_INVOICE] = 'onWatchInvoice';
handlers[ActionTypes.UNWATCH_INVOICE] = 'onUnwatchInvoice';
handlers[ActionTypes.REGENERATE_INVOICE_SUCCESS] = function (action) {
    const response = action.data.entity;
    InvoiceStore.onInvoiceUpdateSuccess(response);
    InvoiceStore.emitChange(INVOICE_UPDATE_EVENT);
};
handlers[ActionTypes.REGENERATE_INVOICE_FAIL] = function (action) {
    InvoiceStore.onInvoiceUpdateFail(action);
};
handlers[ActionTypes.UPDATE_INVOICE_SUCCESS] = function (action) {
    const response = action.data.entity;
    InvoiceStore.onInvoiceUpdateSuccess(response);
    InvoiceStore.emitChange(INVOICE_UPDATE_EVENT);
};
handlers[ActionTypes.REGENERATE_INVOICE_FAIL] = function (action) {
    InvoiceStore.onInvoiceUpdateFail(action);
};
handlers[ActionTypes.ADD_INVOICES] = 'onAddInvoices';
registerStore(InvoiceStore, AdminAppDispatcher, handlers);
export default InvoiceStore;
